import { FileTypes } from '@/models/FileTypes';

import { ActionType, getType } from 'typesafe-actions';

import * as fileManagementActions from './actions';

type fileManagementActionType = ActionType<typeof fileManagementActions>;

export type FileManagementState = {
  fileTypes: {
    data: FileTypes[];
    loading: boolean;
  };
};

const initialState: FileManagementState = {
  fileTypes: {
    data: [],
    loading: false,
  },
};

export const fileManagementReducer = (
  state = initialState,
  action: fileManagementActionType,
) => {
  switch (action.type) {
    case getType(fileManagementActions.getFileTypes.request):
      return {
        ...state,
        fileTypes: {
          ...state.fileTypes,
          loading: true,
        },
      };
    case getType(fileManagementActions.getFileTypes.success):
      return {
        ...state,
        fileTypes: {
          ...state.fileTypes,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(fileManagementActions.getFileTypes.failure):
      return {
        ...state,
        fileTypes: {
          ...state.fileTypes,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default fileManagementReducer;
